//#region src/core/i18n/locales/sv.ts
var sv_default = {
	buttons: {
		play: "Spela",
		pause: "Pausa",
		replay: "Spela upp igen",
		mute: "Ljud av",
		unmute: "Ljud på"
	},
	seek: {
		forward: "Hoppa framåt {seconds} sekunder",
		backward: "Hoppa bakåt {seconds} sekunder"
	},
	fullscreen: {
		enter: "Fullskärm",
		exit: "Avsluta fullskärm"
	},
	captions: {
		enable: "Aktivera textning",
		disable: "Inaktivera textning"
	},
	pip: {
		enter: "Bild-i-bild",
		exit: "Avsluta bild-i-bild"
	},
	live: {
		playing: "Spelar live",
		seekToEdge: "Gå till live",
		badge: "Live"
	},
	cast: {
		start: "Starta casting",
		stop: "Stoppa casting",
		connecting: "Ansluter"
	},
	airplay: {
		start: "Starta AirPlay",
		stop: "Stoppa AirPlay"
	},
	slider: { seek: "Spola" },
	time: {
		current: "Aktuell tid",
		duration: "Total tid",
		remaining: "Återstående tid",
		elapsedSuffix: "{duration} förfluten tid",
		durationSuffix: "{duration} varaktighet",
		remainingSuffix: "{duration} kvar",
		showElapsed: "Visa förfluten tid, {duration}.",
		showDuration: "Visa längd, {duration}.",
		showRemaining: "Visa återstående tid, {duration}.",
		toggleElapsed: "Växla mellan förfluten och återstående tid.",
		toggleDuration: "Växla mellan varaktighet och återstående tid.",
		position: "{current} av {duration}",
		unknown: "Mediet laddades inte, okänd tid."
	},
	playback: { rate: "Uppspelningshastighet {rate}" },
	volume: {
		mutedValue: "{percent}, tystat",
		muted: "Tystat",
		label: "Volym",
		value: "Volym {value}"
	},
	status: {
		captionsOn: "Text på",
		captionsOff: "Text av",
		paused: "Pausad",
		playing: "Spelar",
		fullscreen: "Fullskärm",
		pip: "Bild i bild",
		exitPip: "Avsluta bild i bild",
		seekedTo: "Hoppade till {time}"
	},
	container: { label: "Mediaspelare" },
	errors: {
		aborted: "Du har avbrutit videouppspelningen.",
		network: "Ett nätverksfel gjorde att nedladdningen av videon avbröts.",
		decode: "Uppspelningen avbröts på grund av att videon är skadad, eller också för att videon använder funktioner som din webbläsare inte stöder.",
		source: "Det gick inte att ladda videon, antingen på grund av ett server- eller nätverksfel, eller för att formatet inte stöds.",
		encrypted: "Mediat är krypterat och vi har inte nycklarna för att dekryptera det.",
		unplayable: "Det här mediet stöds inte av spelaren.",
		title: "Något gick fel.",
		unexpected: "Ett fel uppstod. Försök igen."
	},
	common: {
		empty: "",
		ok: "Stäng"
	},
	menu: {
		settings: "Inställningar",
		quality: "Kvalitet",
		audio: "Ljud",
		default: "Standard",
		speed: "Hastighet",
		captions: "Textning",
		playbackRate: "Uppspelningshastighet",
		back: "Tillbaka",
		off: "Av",
		auto: "Auto",
		autoWithLabel: "Auto ({label})",
		subtitles: "Undertexter"
	}
};
//#endregion
export { sv_default as default };

//# sourceMappingURL=sv.js.map